import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../components/content/axiosConfig';
import { queryKeys } from './queryKeys';
import { normalizeUnitsData } from './useLengthUnits';

export function useWeightUnits(params = {}, options = {}) {
  return useQuery({
    queryKey: queryKeys.weightUnits(params),
    queryFn: async () => {
      const response = await axiosInstance.get('/api/WeightUnit/GetAll', { params });
      return response.data;
    },
    staleTime: 60 * 60_000,
    ...options,
  });
}

export { normalizeUnitsData };
